<template>
	<div
		class="w-full tip-container grid gap-y-4 px-4 md:mt-4  md:grid-cols-2 md:gap-x-4 lg:mt-8 lg:gap-x-8 lg:gap-y-6 xl:w-4/12 xl:mt-0 xl:grid-cols-1 xl:gap-x-0 xl:px-3 xl:-mx-3"
		v-if="filteredTips.length"
	>
		<router-link
			:to="`/tips/${item.id}`"
			v-for="(item, index) in filteredTips"
			:key="`tip-${index}`"
		>
			<TipItem class="cursor-pointer" v-bind="item" />
		</router-link>
	</div>
	<div
		v-else
		class="w-full tip-container px-4 md:mt-4 md:grid md:grid-cols-2 md:gap-x-4 lg:mt-8 lg:gap-x-8 lg:gap-y-4 xl:w-4/12 xl:mt-0 xl:grid-cols-1 xl:gap-x-0 xl:px-0"
	>
		<div
			class="flex flex-col items-stretch justify-between  rounded-3xl mb-4 tip-item px-3 xl:px-5 py-20 dark:text-white  border-dashed border-4 border-bs-blue-dark"
		>
			<h1 class="text-xl font-black" >{{ emptyTitle }}</h1>
			<p>{{ emptyMessage }}</p>
		</div>
	</div>
</template>

<script>
import { formatDistanceToNow } from "date-fns";
import TipItem from "@/components/atoms/TipItem.vue";
import { mapGetters } from "vuex";
export default {
	components: {
		TipItem,
	},
	props: {
		which: {
			type: String,
			default: undefined,
		},
	},
	computed: {
		...mapGetters(["tips"]),
		formattedTips: function () {
			return this.tips?.map((t) => {
				let {
					status: statusLabel,
					class: statusClass,
					icon: statusIcon,
				} = this.getStatus(t.status);
				return {
					...t,
					formattedDate: this.formatDate(t.createdDate),
					statusLabel,
					statusClass,
					statusIcon,
				};
			}) || [];
		},
		filteredTips: function () {
			if (!this.which) {
				// No filter — show all tips (existing behavior)
				return this.formattedTips;
			}
			return this.formattedTips
				.filter((t) =>
					this.which === "ALL" ? t.status !== "PENDING" : t.status === this.which
				)
				.filter((t) => t.virtualEquityAfterTip !== null);
		},
		emptyTitle: function () {
			if (!this.which) return "No tips yet.";
			return "No matches in this filter.";
		},
		emptyMessage: function () {
			if (!this.which) return "New tips will come here.";
			return "Try a different status.";
		},
	},
	methods: {
		formatDate: function (str) {
			try {
				let d = new Date(str);
				if (d) {
					return formatDistanceToNow(d,{ addSuffix: true });
				}
			} catch (e) {
				console.log(e);
			}
		},
		getStatus: function (status) {
			switch (status) {
				case 0:
				case "0":
				case "PENDING":
					return { status: "Pending", class: "is-pending" };
				case 1:
				case "1":
				case "SUCCESS":
					return { status: "Success", class: "is-win" };
				case 2:
				case "2":
				case "FAIL":
					return { status: "Fail", class: "is-loss" };
				case 3:
				case "3":
				case "VOID":
					return { status: "Void", class: "is-void" };
				case 4:
				case "4":
				case "HALFWIN":
					return { status: "Half Win", class: "is-half-win" };
				case 5:
				case "5":
				case "HALFLOSS":
					return { status: "Half Loss", class: "is-half-loss" };
			}
		},
	},
};
</script>

<style>
@screen md {
	.tip-container {
		-ms-overflow-style: none;
		scrollbar-width: none;
		min-width: 340px;
	}
	.tip-container::-webkit-scrollbar {
		display: none;
	}
}
@screen 2xl {
	.tip-container {
		max-width: 600px;
	}
}
</style>
